// sessionVir.js

export function setAuthToken(token)   { localStorage.setItem('token', token); }
export function getAuthToken()        { return localStorage.getItem('token'); }
export function setPortfolioId(id)   { localStorage.setItem('portfolioId', id); }
export function getPortfolioId()      { return localStorage.getItem('portfolioId'); }
export function setSessionId(id)     { localStorage.setItem('sessionId', id); }
export function getSessionId()        { return localStorage.getItem('sessionId'); }
export function setRole(role)        { localStorage.setItem('role', role); }
export function getRole()             { return localStorage.getItem('role'); }
export function setFirstLogin(flag)  { localStorage.setItem('firstLogin', flag ? 'true' : 'false'); }
export function getFirstLogin()       { return localStorage.getItem('firstLogin') === 'true'; }